import "./slow-connection.scss";

import { useSlowConnection } from "@client/hooks/useSlowConnection";
import { LABELS } from "@client/utils/labels";

export function SlowConnection() {
	const isSlow = useSlowConnection();

	if (!isSlow) return null;

	return (
		<div className="slow-connection" role="status">
			{LABELS.slowInternetConnection}
		</div>
	);
}
